// Активная страна карты для слоя данных.
//
// Почему модульное состояние, а не проп через 24 файла: загрузчики и query-ключи
// вызываются из 50+ мест, и протаскивание `cc` через каждое дало бы огромный диф
// с высоким риском регрессии на работающей карте Италии. Карта в приложении
// всегда одна и задаётся роутом, поэтому активная страна — свойство роута,
// а не отдельного компонента.
//
// Инвариант: значение выставляет ТОЛЬКО роут карты (см. MapWithHeader в App.tsx),
// синхронно, до рендера потребителей. Все query-ключи включают активную страну,
// поэтому React Query не отдаст данные Италии, когда открыта другая страна.

import { DEFAULT_MAP_COUNTRY, isMapCountry, mapCountryConfig, type MapCountry, type MapCountryConfig } from '@/features/map-core/countries';

let active: MapCountry = DEFAULT_MAP_COUNTRY;

export function setActiveMapCountry(cc: string): MapCountry {
  active = isMapCountry(cc) ? cc : DEFAULT_MAP_COUNTRY;
  return active;
}

export function activeMapCountry(): MapCountry {
  return active;
}

export function activeMapCountryConfig(): MapCountryConfig {
  return mapCountryConfig(active);
}
